import { byWindowAction } from '@html/_common/utils';

export default function AOScoutAccordion({ selector, onExpand, onCollapse } = {}) {
  const $accordionElements = '.js-ao-scout-accordion';
  const ACTIVE_ACCORDION = 'active';
  const DISABLED_ACCORDION = 'js-ao-scout-accordion--disabled';
  const EXPANDED_CLASS = 'ao-scout-accordion--expanded';
  const COLLAPSED_CLASS = 'ao-scout-accordion--collapsed';
  const TRANSITION_CLASS = 'ao-scout-accordion--transition';
  const ARROW_ACTIVE_CLASS = 'ao-scout-accordion__arrow--active';
  const ACCORDION_BOTTOM_SELECTOR = '.js-ao-scout-accordion__bottom';

  const ARROW_SELECTOR = '.js-ao-scout-accordion__arrow';

  this.initiate = () => {
    this.accordions.initiate();
  };

  this.accordions = {
    TRANSITION_DURATION: 300,
    SELECTOR_ACCORDION_TOPS: `.js-ao-scout-accordion:not(.${TRANSITION_CLASS}) .js-ao-scout-accordion__content-top`,

    initiate: () => {
      const $accordionSelector = $(selector || window).find($accordionElements);
      const that = this.accordions;

      that.body = $('body');

      $accordionSelector.on('click', that.SELECTOR_ACCORDION_TOPS, that.onClickTop);

      byWindowAction(['resize'], that.setMaxHeight);
    },

    onClickTop: (event) => {
      const that = this.accordions;
      const $accordionElement = $(event.currentTarget).closest($accordionElements);
      const eventType = that.toggleActive(event);
      const isCollapseEvent = eventType === 'collapse';

      $accordionElement.toggleClass(TRANSITION_CLASS, true);
      $accordionElement.toggleClass(COLLAPSED_CLASS)
        .toggleClass('js-ao-scout-accordion--collapsed')
        .toggleClass(EXPANDED_CLASS);
      $accordionElement
        .find('.ao-scout-accordion__content')
        .toggleClass('ao-scout-accordion--active');
      $accordionElement
        .find('.js-ao-scout-accordion__bottom')
        .css('max-height', isCollapseEvent ? '0' : '100%');

      setTimeout(() => $accordionElement.toggleClass(TRANSITION_CLASS, false), that.TRANSITION_DURATION);
    },

    setMaxHeight: (element) => {
      const $accordionBottomElements = element.$accordionBottomElement || $(`.js-ao-scout-accordion.${EXPANDED_CLASS} ${ACCORDION_BOTTOM_SELECTOR}`);

      $accordionBottomElements.each((index) => {
        const $accordionBottomElement = $($accordionBottomElements.get(index));
        $accordionBottomElement.css('max-height', '100%');
      });
    },

    toggleActive: (event) => {
      const $clicked = $(event.currentTarget);
      const $parent = $clicked.parent();
      const $accordionElement = $clicked.closest($accordionElements);
      const eventCategory = $accordionElement.data('category-name');
      const blockName = $accordionElement.data('category-name');
      const sectionLabel = $clicked.text().trim();

      if ($parent.hasClass(ACTIVE_ACCORDION) && !$accordionElement.hasClass(DISABLED_ACCORDION)) {
        $accordionElement.trigger('collapse');

        $parent.removeClass(ACTIVE_ACCORDION);
        $parent.find(ARROW_SELECTOR).removeClass(ARROW_ACTIVE_CLASS);

        onCollapse?.({
          eventCategory,
          blockName,
          sectionLabel,
        });
        return 'collapse';
      } if (!$accordionElement.hasClass(DISABLED_ACCORDION)) {
        $accordionElement.trigger('expand');

        $parent.addClass(ACTIVE_ACCORDION);
        $parent.find(ARROW_SELECTOR).addClass(ARROW_ACTIVE_CLASS);

        onExpand?.({
          eventCategory,
          blockName,
          sectionLabel,
        });
        return 'expand';
      }
      return '';
    },

    toggleMultipleAccordions: (listOfAccordions, action) => {
      const that = this.accordions;

      listOfAccordions.forEach((accordion) => {
        const $accordionElement = $(accordion).closest($accordionElements);
        $accordionElement.toggleClass(TRANSITION_CLASS, true);

        if (action === 'expand') {
          $accordionElement.removeClass(COLLAPSED_CLASS)
            .removeClass('js-ao-scout-accordion--collapsed')
            .addClass(EXPANDED_CLASS);
          $accordionElement.find('.ao-scout-accordion__content').addClass(ACTIVE_ACCORDION);
        } else if (action === 'collapse') {
          $accordionElement.addClass(COLLAPSED_CLASS)
            .addClass('js-ao-scout-accordion--collapsed')
            .removeClass(EXPANDED_CLASS);
          $accordionElement.find('.ao-scout-accordion__content').removeClass(ACTIVE_ACCORDION);
        }
        setTimeout(() => {
          $accordionElement.toggleClass(TRANSITION_CLASS, false);
        }, that.TRANSITION_DURATION);
      });
    },
  };
}
